import { API, Item } from "@thenounproject/lingo-core";
import { createQueryAction } from "../actionCreators";

type Args = {
  spaceId: string | number;
  itemId: string | number;
  version: number;
  assetToken?: string;
};

const [useItem, fetchItem] = createQueryAction<Args, Item, string>(
  {
    entity: "items",
    action: "fetch",
    denormalize: { asset: "assets", item: "items" },
    condition: ({ args }) => Boolean(args.itemId),
  },
  async ({ args }) => {
    const res = await API.call<{ item: string }>({
      endpoint: `spaces/${args.spaceId}/items/${args.itemId}`,
      method: "GET",
      query: {
        asset_token: args.assetToken,
        v: args.version,
      },
    });
    return { ...res, result: res.result.item };
  }
);

export default useItem;
export { fetchItem };
